import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import auth from '../utils/auth';

export const getAuthHeaders = (headers) => {
    let token = auth.getToken();
    let sessionKey = auth.getSID();
    if (sessionKey) {
        headers.set('session-key', sessionKey);
    }
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
};

// Define a service using a base URL and expected endpoints
export const customersApi = createApi({
    reducerPath: 'customersApi',
    tagTypes: ['Customer'],
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        prepareHeaders: getAuthHeaders
    }),
    endpoints: (builder) => ({
        getCustomerById: builder.query({
            query: (id) => `/customers/${id}`,
            providesTags: (result, error, id) => [{ type: 'Customer', id }]
        }),
        updateCustomerById: builder.mutation({
            query: ({ id, ...patch }) => ({
                url: `/customers/${id}`,
                method: 'PUT',
                body: patch
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Customer', id }]
        }),
        getUsers: builder.query({
            query: (filters) => `/customers${filters}`
        })
    })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUsersQuery, useGetCustomerByIdQuery, useUpdateCustomerByIdMutation } = customersApi;
